import Vue from "vue";
import App from "./App.vue";
import { i18n } from "./locales";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "leaflet/dist/leaflet.css";
import { createRouter } from "@/router/index.js";
import {
  applyPolyfills,
  defineCustomElements,
} from "slf-web-components/dist/loader";
import { EnvironmentService } from "@/services/EnvironmentService";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.config.productionTip = false;

async function startApp(): Promise<void> {
  // setup slf-web-components
  await applyPolyfills();
  await defineCustomElements();

  await EnvironmentService.initialize();

  new Vue({
    i18n,
    router: createRouter(),
    render: (h) => h(App),
  }).$mount("#app");
}

startApp().then();
